import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'sd-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: [
    './modal-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalFooterComponent implements OnInit {
  isMobileOrTablet = false;
  constructor(deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }

  ngOnInit() {
  }

}
